import { WaffleFlag } from "@alch/dx-entities";
import { callEndpoint, Method } from "@http/axiosConfig";
import { useQuery } from "@tanstack/react-query";
import { WaffleFlagObj } from "@typedefs/waffle";

export function useIsWaffleFlagEnabled(flagName: WaffleFlag) {
  // This is causing elevated latency on the webapp waffle endpoints.
  // Switching to django endpoint for now while we figure out the cause.
  // https://alchemyinsights.slack.com/archives/C03JX8DJP40/p1744660077188009
  //
  // return trpc.waffle.isFlagEnabled.useQuery({
  //   flagName,
  // });

  return useQuery({
    queryKey: ["featureFlags", flagName],
    queryFn: () =>
      callEndpoint<WaffleFlagObj[]>(Method.GET, "/api/waffle/flags", {
        flags: [flagName],
      }),
    select: (flags) =>
      flags.find((flag) => flag.name === flagName)?.active ?? false,
    staleTime: 60 * 1000,
  });
}
